import { forwardRef } from 'react'
import classNames from 'classnames/bind'
import PropTypes from 'prop-types'
import Icon from 'vv-icon-component'

import icons from '../../assets/icomoon/export'
import styles from './Button.module.scss'

const cx = classNames.bind(styles)

const Button = forwardRef(
  (
    { children, classes, disabled, extraProps, iconName, id, onPress, type },
    ref
  ) => (
    <button
      className={`${styles.btn} ${cx(classes)}`}
      disabled={disabled}
      id={id}
      onClick={onPress}
      // eslint-disable-next-line react/button-has-type
      type={type}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...extraProps}
      ref={ref}
    >
      <span className='btn-text'>{children}</span>
      {iconName && (
        <div className='btn-icon'>
          <Icon icon={iconName} icons={icons} />
        </div>
      )}
    </button>
  )
)

Button.displayName = 'Button'

Button.defaultProps = {
  children: null,
  classes: {},
  disabled: false,
  extraProps: null,
  iconName: null,
  id: '',
  onPress: () => {},
  type: 'button',
}

/* TODO */
// Do onPress prop required only if a type prop is not submit.
Button.propTypes = {
  children: PropTypes.string,
  classes: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  disabled: PropTypes.bool,
  extraProps: PropTypes.shape({}),
  iconName: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  id: PropTypes.string,
  onPress: PropTypes.func,
  type: PropTypes.string,
}

export default Button
